import { PromptIcon, generateTitleFromPrompt } from "@1js/pl-card-components";
import type { Prompt } from "@1js/pl-types";
import { isExtensionPrompt } from "@1js/pl-types";
import {
  Text,
  makeStyles,
  shorthands,
  tokens,
} from "@fluentui/react-components";
import * as React from "react";

type Props = {
  prompt: Prompt;
};

const useStyles = makeStyles({
  title: {
    display: "flex",
    alignItems: "center",
    alignSelf: "stretch",
    ...shorthands.gap("4px"),
  },

  titleText: {
    color: tokens.colorNeutralForeground1,
    textOverflow: "ellipsis",
    whitespace: "nowrap",
    display: "-webkit-box",
    WebkitLineClamp: "2",
    WebkitBoxOrient: "vertical",
    fontSize: "1.5rem",
    fontStyle: "normal",
    fontWeight: tokens.fontWeightSemibold,
    lineHeight: "2rem",
    ...shorthands.overflow("hidden"),

    "@media (max-width: 540px)": {
      fontSize: "1.25rem",
      lineHeight: "normal",
    },
  },
});

export const PromptDetailTitle: React.FC<Props> = ({ prompt }) => {
  const styles = useStyles();
  const title =
    isExtensionPrompt(prompt) && !prompt?.Title
      ? generateTitleFromPrompt(prompt)
      : prompt.Title;

  return (
    <div className={styles.title}>
      <PromptIcon displayCategory={prompt.DisplayCategory} appearance="web" />
      <Text data-testid="detail-title" className={styles.titleText}>
        {title}
      </Text>
    </div>
  );
};
